/* istanbul ignore file */
export const regexConstants = {
  ALPHA_NUM_AND_HYPHEN: /^[a-zA-Z0-9-]*$/g,
};

export const routesConstants = {
  CATEGORIES: '/app/categories',
};
